module.exports = __webpack_public_path__ + "img/eye.8ade91ac.svg";